import {ResourceParams} from "../resources";

export type DropdownSettingsResourceType =
  'themes' |
  'blogger-statuses' |
  'ad-statuses' |
  'platforms' |
  'blogger-quality' |
  'product-lines' |
  'product-supplies' |
  'product-groupss' |
  'product-categories' |
  'hypothesis-types' |
  'task-descriptions' |
  'video-types' |
  'product-weights' |
  'product-colors' |
  'product-scents' |
  'product-volumes' |
  'wildberries-campaign-types';

export const dropdownSettingsResources: {
  [key in DropdownSettingsResourceType]: ResourceParams
} = {
  'themes': {
    key: 'themes',
    name: 'Темы канала',
    path: 'themes',
  },
  'blogger-statuses': {
    key: 'blogger-statuses',
    name: 'Статус блогера',
    path: 'blogger-statuses',
  },
  'ad-statuses': {
    key: 'ad-statuses',
    name: 'Статус рекламы',
    path: 'ad-statuses',
  },
  'platforms': {
    key: 'platforms',
    name: 'Платформа',
    path: 'platforms',
  },
  'blogger-quality': {
    key: 'blogger-quality',
    name: 'Качества блогера',
    path: 'blogger-quality',
  },
  'product-lines': {
    key: 'product-lines',
    name: 'Линейки продуктов',
    path: 'product-lines',
  },
  'product-supplies': {
    key: 'product-supplies',
    name: 'Поставки продуктов',
    path: 'product-supplies',
  },
  'product-groupss': {
    key: 'product-groupss',
    name: 'Группы продуктов',
    path: 'product-groupss',
  },
  'product-categories': {
    key: 'product-categories',
    name: 'Категории продуктов',
    path: 'product-categories',
  },
  'hypothesis-types': {
    key: 'hypothesis-types',
    name: 'Типы гипотез',
    path: 'hypothesis-types',
  },
  'task-descriptions': {
    key: 'task-descriptions',
    name: 'Технические задания',
    path: 'task-descriptions'
  },
  'video-types': {
    key: 'video-types',
    name: 'Тип ролика',
    path: 'video-types'
  },
  'product-weights': {
    key: 'product-weights',
    name: 'Вес продукта',
    path: 'product-weights'
  },
  'product-colors': {
    key: 'product-colors',
    name: 'Цвет продукта',
    path: 'product-colors'
  },
  'product-scents': {
    key: 'product-scents',
    name: 'Запах продукта',
    path: 'product-scents'
  },
  'product-volumes': {
    key: 'product-volumes',
    name: 'Литраж/объём продукта',
    path: 'product-volumes'
  },
  'wildberries-campaign-types': {
    key: 'wildberries-campaign-types',
    name: 'Тип рекламной кампании WB',
    path: 'wildberries-campaign-types'
  }
};
